"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalActions = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var AdditionalActions;
(function (AdditionalActions) {
    AdditionalActions["BRAND_VOICE_GENERATION"] = "BRAND_VOICE_GENERATION";
    AdditionalActions["BRAND_VOICE_USE"] = "BRAND_VOICE_USE";
    AdditionalActions["BrandVoiceGeneration"] = "BRAND_VOICE_GENERATION";
    AdditionalActions["BrandVoiceUse"] = "BRAND_VOICE_USE";
})(AdditionalActions || (exports.AdditionalActions = AdditionalActions = {}));
